import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import { findAssignCourse, listTopics, dragAndDrop } from "../../api/itpApi";
import Loader from "../../components/common/loader";
import { ResponseStatusEnum } from "../../utils/helpers/enums";
import { getRole } from "../../utils/helpers/custom";
import DragndropTable from "../../components/common/dragndropTable";
import { toast } from "react-toastify";
import TableContainer from "../../components/common/tableContainer";
import { checkStatusCodeSuccess, CommonLabel, Roles } from "../../utils/helpers/common";
import { ItpLabel } from "../../common/constant/Itp";
import NoResultsMessage from "../../components/noResultMessage";

const ItpDetails = () => {
  const { courseId } = useParams();
  const location = useLocation();
  const selectedCourseName = location.state?.courseName;
  const role = getRole();
  const [loading, setLoading] = useState(false);
  const [topic, setTopic] = useState([]);
  const [courseName, setCourseName] = useState([]);
  const [assignCourse, setAssignCourse] = useState([]);
  console.log('selectd', selectedCourseName);

  const listAssignCourseFunAddBY = () => {
    setLoading(true);
    listTopics({
      courseId: courseId,
    })
      .then((res) => {
        if (checkStatusCodeSuccess(res?.data?.statusCode)) {
          setCourseName(res?.data?.data[0]?.courseName);
          setTopic(res?.data?.data[0]?.topic);
        } else {
          setTopic([]);
        }
      })
      .catch((err) => err)
      .finally(() => {
        setLoading(false);
      });
  };

  const listAssignCourseFunAssignBy = () => {
    findAssignCourse({ courseId: parseInt(courseId) })
      .then((response) => {
        if (response?.data?.message === "Data not found.") {
          setAssignCourse([]);
        } else {
          setAssignCourse(response?.data?.data);
        }
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (role === Roles.Admin || role === Roles.HR) {
      listAssignCourseFunAddBY();
    }
    if (role === Roles.BDE || role === Roles.Employee) {
      listAssignCourseFunAssignBy();
    }
  }, []);

  const onDragEnd = (result) => {
    if (!result || !result?.destination) {
      return;
    }

    if (result?.source?.droppableId !== result?.destination?.droppableId) {
      return;
    }

    const fromIndex = result?.source?.index;
    const toIndex = result?.destination?.index;
    const draggedTopic = topic[fromIndex];

    const items = [...topic];
    items.splice(fromIndex, 1);
    items.splice(toIndex, 0, draggedTopic);

    setTopic(items);
    const insertdata = [];
    for (let key of items) {
      insertdata?.push({
        id: key?.id,
        courseId: key?.courseId,
        topicName: key?.topicName,
        link: key?.link,
        hour: key?.hour,
      });
    }

    let payload = {
      topic: insertdata,
    };

    dragAndDrop(payload)
      .then((response) => {
        if (checkStatusCodeSuccess(response?.data?.statusCode)) {
          listAssignCourseFunAddBY();
          toast.success(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.data?.message);
        return error;
      });
  };

  const QueryColumns = useMemo(() => {
    const columns = [
      {
        Header: ItpLabel.TopicName,
        accessor: "topicName",
        filterable: false,
      },
      {
        Header: ItpLabel.Hour,
        accessor: "hour",
        filterable: false,
      },
      {
        Header: ItpLabel.Remark,
        accessor: "remark",
        filterable: false,
      },
      {
        Header: ItpLabel.Link,
        Cell: (cellProps) => {
          const Celldata = cellProps.row.original.link;
          return (
            <div>
              <div className="hstack gap-2">
                <a href={Celldata} target="_blank">
                  {Celldata}
                </a>
              </div>
            </div>
          );
        },
        accessor: "link",
        filterable: false,
      },
    ];

    if (role === Roles.Admin || role === Roles.HR) {
      columns.unshift({
        Header: CommonLabel.Action,
        Cell: () => (
          <div>
            <i className="bx bx-menu"></i>
          </div>
        ),
      });
    }

    return columns;
  }, [role]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={ItpLabel.ItpDetail} pageTitle="HRMS" />
        <div className="d-flex justify-content-end mb-2">
          <Link to={"/itp"} className="btn btn-primary">
            {CommonLabel.Back}
          </Link>
        </div>
        <Card>

          {(role === Roles.Admin || role === Roles.HR) && (
          <>
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1 ">{courseName}</h4>
          </CardHeader>
            <CardBody>
              {topic?.length || loading ? (
                <DragndropTable
                  columns={QueryColumns}
                  data={topic || []}
                  isAddUserList={false}
                  isGlobalFilter={true}
                  customPageSize={5}
                  tableLoader={loading}
                  divClass="table-responsive table-card mb-1"
                  tableClass="align-middle table-wrap"
                  theadClass="table-light text-muted"
                  onDragEnd={onDragEnd}
                />
              ) : (
                <NoResultsMessage />
              )}
            </CardBody>
          </>
          )}
          {(role === Roles.Employee || role === Roles.BDE) && (
          <>
            <CardHeader className="align-items-center d-flex">
              <h4 className="card-title mb-0 flex-grow-1 ">{selectedCourseName}</h4>
            </CardHeader>
            <CardBody>
              {assignCourse?.length || loading ? (
                <TableContainer
                  columns={QueryColumns}
                  data={assignCourse || []}
                  isAddUserList={false}
                  customPageSize={5}
                  tableLoader={loading}
                  divClass="table-responsive table-card mb-1"
                  tableClass="align-middle table-wrap"
                  theadClass="table-light text-muted"
                  onDragEnd={onDragEnd}
                />
              ) : (
                <NoResultsMessage />
              )}
            </CardBody>
            </>
          )}
        </Card>
      </Container>
    </div>
  );
};

export default ItpDetails;
